export const UPDATE_DICTIONARY_WORD = {
  START: 'START_UPDATE_DICTIONARY_WORD',
  COMPLETE: 'COMPLETE_UPDATE_DICTIONARY_WORD',
  FAIL: 'FAIL_UPDATE_DICTIONARY_WORD',
}

export const DELETE_DICTIONARY_WORD = {
  START: 'START_DELETE_DICTIONARY_WORD',
  COMPLETE: 'COMPLETE_DELETE_DICTIONARY_WORD',
  FAIL: 'FAIL_DELETE_DICTIONARY_WORD',
}

export const MOVE_DICTIONARY_WORD_TO_TYPE = {
  START: 'START_MOVE_DICTIONARY_WORD_TO_TYPE',
  COMPLETE: 'COMPLETE_MOVE_DICTIONARY_WORD_TO_TYPE',
  FAIL: 'FAIL_MOVE_DICTIONARY_WORD_TO_TYPE',
}
